import { createBrowserRouter, RouterProvider } from 'react-router';
import { Title } from '@mantine/core';
import { Quote } from '@/components/Quote/';
import { SlimQuote } from '@/components/Quote/SlimQuote';
import { Basic } from '@/pages/Basic.layout';

// Cost-reduction pass (2026-08-03): every route except /quote and
// /slim-quote was pulled out of the app (imports, mailers, admin, auth,
// property-lookup, retrieve, etc.) along with the backend infra that only
// they used. The homepage is now just a placeholder. See git history for
// the previous Router.tsx if any of this needs to come back.
const NotFound = () => <h1>Not Found</h1>;

function Home() {
  return <Title order={2}>Team Cecero</Title>;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Basic>
        <Home />
      </Basic>
    ),
    errorElement: <NotFound />,
  },
  {
    path: 'quote',
    element: (
      <Basic>
        <Quote />
      </Basic>
    ),
  },
  {
    path: 'slim-quote',
    element: (
      <Basic>
        <SlimQuote />
      </Basic>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
